<template>
    <li v-for="(menuitem, index) in menu" :key="`_root${index}`">

        <!-- Menu Cha -->
        <button v-if="menuitem.items && root"
            v-styleclass="{ selector: '@next', enterFromClass: 'hidden', enterActiveClass: 'animate-slidedown', leaveToClass: 'hidden', leaveActiveClass: 'animate-slideup' }"
            type="button">
            <span class="menu-icon">
                <i :class="menuitem.icon"></i>
            </span>
            <span>{{ menuitem.ten_menu }}</span>
            <i class="menu-toggle-icon pi pi-angle-down"></i>
        </button>

        <!-- <a v-if="menuitem.href" :href="menuitem.href" target="_blank" rel="noopener noreferrer">
            <span v-if="menuitem.icon && root" class="menu-icon">
                <i :class="menuitem.icon"></i>
            </span>
            <span>{{ menuitem.ten_menu }}</span>
            <Tag v-if="menuitem.badge" :value="menuitem.badge"></Tag>
        </a> -->

        <NuxtLink v-if="menuitem.path" :to="menuitem.path"
            :class="{ 'router-link-active': menuitem.path === $route.path || $route.path.startsWith(menuitem.path + '/') }">
            <span v-if="menuitem.icon" class="menu-icon">
                <i :class="[menuitem.icon, !root ? 'mr-1' :'', 'w-[14px]']"></i>
            </span>
            <span>{{ menuitem.ten_menu }}</span>
            <Tag v-if="menuitem.badge" :value="menuitem.badge"></Tag>
        </NuxtLink>

        <span v-if="!root && menuitem.items && menuitem.items.length > 0" class="menu-child-category">{{ menuitem.ten_menu }}</span>
        <div v-if="menuitem.items"
            class="overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
            <ol>
                <AppMenuItem :root="false" :menu="menuitem.items"></AppMenuItem>
            </ol>
        </div>
    </li>
</template>

<script>
export default {
    props: {
        root: {
            type: Boolean,
            default: true
        },
        menu: {
            type: Object,
            default: null
        }
    },
    methods: {
        isActiveRootmenuItem(menuitem) {
            return (
                menuitem.items &&
                !menuitem.items.some((item) => {
                    const currentPath = this.$router.currentRoute.value.fullPath;
                    return item.path === currentPath || (item.items && item.items.some((it) => it.path === currentPath));
                })
            );
        }
    }
};
</script>
